<template>
  <div class="home">
    <div class="home_nr">
      <div class="logon">
        <a-form ref="formRef" :rules="rules" :model="formState" layout="vertical">
          <a-form-item style="row-gap: 0px" name="user">
            <a-input allow-clear v-model:value="formState.user" placeholder="请输入用户名">
              <template #prefix><UserOutlined style="color: rgba(0, 240, 0, 1)" /></template>
            </a-input>
          </a-form-item>
          <a-form-item style="row-gap: 0px" name="password">
            <a-input v-model:value="formState.password" :type="type1" placeholder="请输入密码">
              <template #prefix><LockOutlined style="color: rgba(0, 240, 0, 1)" /></template>
              <template #suffix>
                <EyeOutlined @click="changeType" v-if="type1 == 'text'" />
                <EyeInvisibleOutlined @click="changeType" v-else />
              </template>
            </a-input>
          </a-form-item>
          <a-row class="three-row">
            <a-col :span="12" style="text-align: left">
              <a-checkbox v-model:checked="checked" style="padding-left: -20px"
                >自动登录</a-checkbox
              >
            </a-col>
            <a-col class="ccc" :span="12" style="text-align: right">
              <a-span @click="wjpassword">忘记密码?</a-span>
              <!-- <a  @click="wjpassword" style="background: ;">忘记密码?</a> -->
            </a-col>
          </a-row>
          <a-form-item>
            <a-button @click="submit" type="primary" class="submit-class"> 提交 </a-button>
          </a-form-item>
          <!-- <div style="width:330px;margin:0 auto; padding:20px 0;">
              <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
          </div>  -->
        </a-form>
      </div>
        <div class="logotp">
        <img class="logoccc" src="../../assets/image2/logo.png" />
        <div  class="logoright">
            <img src="../../assets/beian.png" style="float:left;"/>
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"> <a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p >
          </div>
      </div>
    </div>
    <!-- <div style="width:330px;margin:0 auto; padding:20px 0;">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
    </div> -->
  </div>
</template>

<script>
import { UserOutlined, LockOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons-vue'
import { message } from "ant-design-vue"
import { login, getList,getUserInfo } from '../../utils/api'
export default {
  data () {
    return {
      checked: false,
      type1: 'password',
      canShow: false,
      message: '错误的用户名和密码',
    //   rules: {
    //     user: [
    //       { required: true, message: '用户名是必填项！', trigger: 'blur' }
    //     ],
    //     password: [
    //       { required: true, message: '密码是必填项！', trigger: 'blur' }
    //     ]
    //   },
      formState: {
        user: '',
        password: '',
      }
    }
  },
  mounted () {
  },
  created () {

  },
  methods: {
    changeType () {
      if (this.type1 == 'text') {
        this.type1 = 'password'
      } else {
        this.type1 = 'text'
      }
    },
    submit () {
      let that = this
      this.$refs.formRef.validate().then(() => {
        localStorage.removeItem('token')
        that.canShow = false
        login({
          "password": this.formState.password,
          "userName": this.formState.user
        }).then(res => {
          localStorage.setItem('token', res.token)
          // localStorage.setItem('userName', this.formState.user)
          getUserInfo().then(res1=>{
            localStorage.setItem('userName', res1.user.nickName)
          })
          getList({ pageNo: 1, pageSize: 10 }).then(res => {
            this.$router.push({ path: '/warningList' })
          })
        }).catch(err => {
        })
      }).catch((err) => {
      })

    },
    wjpassword () {
      this.$router.push({ path: '/warningForget' })
    }
  },

  components: {
    UserOutlined,
    LockOutlined,
    EyeOutlined,
    EyeInvisibleOutlined
  },
}
</script>

<style lang="scss" scoped>
.home {
  background-color: #f2f2f2;
  .home_nr {
    background-image: url(../../assets/image2/homebj.png);
    width: 988px;
    height: 486px;
    margin: 60px auto;
    background-size: 100% 100%;
    .logon {
      height: 225px;
      width: 305px;
      margin-left: 510px;
      padding-top: 121px;
    }
    .logotp {
      margin-top: 196px;
      margin-left: 16px;
      height: 31px;
      display: flex;
      align-items: center;
      .logoccc {
        width: 150px;
        height: 31px;
      }
      .logoright{
        // flex: 1;
        width: fit-content;
        margin-left: 344px;
        cursor: pointer;
        position: relative;
        p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
      }
    }
    .ccc {
      color: #06f106;
      cursor: pointer;
    }
    .size {
      color: #f2f2f2;
      font-size: 16px;
      position: relative;
      top: 6px;
    }
    .submit-class {
      width: 320px;
      width: 183px;
      height: 42px;
      background: #000000;
      float: right;
      margin-top: 13px;
    }
  }
}
/deep/.ant-form-vertical .ant-form-item {
  padding-bottom: 0px;
}
</style>